import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'chunks'
})
export class ChunksPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return null;
  }

}
